import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timeoutMs: { type: Number, default: 5 * 60 * 1000 },
    redirectUrl: String
  }

  connect() {
    this.resetTimer = this.resetTimer.bind(this)
    this.events = ["mousemove", "keydown", "touchstart", "click"]
    this.events.forEach(e => document.addEventListener(e, this.resetTimer, { passive: true }))
    this.resetTimer()
  }

  disconnect() {
    this.events.forEach(e => document.removeEventListener(e, this.resetTimer))
    clearTimeout(this.timer)
  }

  resetTimer() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      Turbo.visit(this.redirectUrlValue || window.location.pathname)
    }, this.timeoutMsValue)
  }
}
